/* eslint-disable max-len */
/* eslint-disable curly */
/* eslint-disable eqeqeq */
import { Injectable } from '@angular/core';
import { ThemeService } from './services/theme.service';
import { HomeConfigService } from './services/home-config.service';
import { AccesibilidadService, CitasConfirmacionService, DoctorAlertasService, DoctorEncuestasService, DoctorFarmacosService, DoctorInformacionAdicionalService, DoctorMedicosService, DoctorPacientesService, DoctorPrincipiosActivosService, DoctorProgramasService, MedicosConfiguracionService, PacienteAnaliticasService, PacienteArticulosService, PacienteCitasService, PacienteEncuestasService, PacienteFarmacosService, PacienteIncidenciasService, PacienteIncidenciasTecnicasService, PacienteNotificacionesService, PacientePantallaDeInicioService, PacienteProgramasService, PacientesService, PrincipiosActivosService, ProgramaParametrosService, UsuariosService } from './services/api/services';
import { UtilsService } from './utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class CoreProvider {
  constructor(
    public utilsService: UtilsService,
    public themeService: ThemeService,
    public homeConfigService: HomeConfigService,
    public accesibilidadService: AccesibilidadService,
    public doctorAlertasService: DoctorAlertasService,
    public doctorEncuestasService: DoctorEncuestasService,
    public doctorFarmacosService: DoctorFarmacosService,
    public doctorInformacionAdicionalService: DoctorInformacionAdicionalService,
    public doctorMedicosService: DoctorMedicosService,
    public doctorPacientesService: DoctorPacientesService,
    public doctorPrincipiosActivosService: DoctorPrincipiosActivosService,
    public doctorProgramasService: DoctorProgramasService,
    public doctorProgramaParametrosService: ProgramaParametrosService,
    public pacienteAnaliticasService: PacienteAnaliticasService,
    public pacienteArticulosService: PacienteArticulosService,
    public pacienteCitasService: PacienteCitasService,
    public pacienteEncuestasService: PacienteEncuestasService,
    public pacienteFarmacosService: PacienteFarmacosService,
    public pacienteIncidenciasTecnicasService: PacienteIncidenciasTecnicasService,
    public pacienteIncidenciasService: PacienteIncidenciasService,
    public pacienteNotificacionesService: PacienteNotificacionesService,
    public pacientePantallaDeInicioService: PacientePantallaDeInicioService,
    public pacienteProgramasService: PacienteProgramasService,
    public medicosService: MedicosConfiguracionService,
    public pacientesService: PacientesService,
    public principiosActivosService: PrincipiosActivosService,
    public usuariosService: UsuariosService,
    public citasConfirmacionService: CitasConfirmacionService
  ) { }
}
